import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'




const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

//push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Index',
        component: Index,
        meta: { page: 1 }
    },
    {
        path: '/courseDetails/:id',
        name: 'courseDetails',
        meta: { page: 2 },
        component: () => import(/* webpackChunkName: "about" */ '../views/course/details.vue')


    },
    {
        path: '/courseBuy/:id',
        name: 'courseBuy',
        meta: { page: 2 },
        component: () => import(/* webpackChunkName: "about" */ '../views/course/buy.vue')
    },
    {
        path: '/courseList',
        name: 'courseList',
        meta: { page: 2 },
        component: () => import(/* webpackChunkName: "about" */ '../views/course/list.vue')
    },
    {
        path: '/paymentRes',
        name: 'paymentRes',

        meta: { page: 2 },
        component: () => import(/* webpackChunkName: "about" */ '../views/course/paymentRes.vue')
    },
    {
        path: '/profileIndex',
        name: 'profileIndex',
        meta: { page: 5 },
        component: () => import(/* webpackChunkName: "about" */ '../views/profile/index.vue')
    },
    {
        path: '/profileCourse',
        name: 'profileCourse',
        meta: { page: 5 },
        component: () => import(/* webpackChunkName: "about" */ '../views/profile/course.vue')
    },
    {
        path: '/profileTimetable',
        name: 'profileTimetable',
        meta: { page: 5 },
        component: () => import(/* webpackChunkName: "about" */ '../views/profile/timetable.vue')
    },
    {
        path: '/profileTest',
        name: 'profileTest',
        meta: { page: 5 },
        component: () => import(/* webpackChunkName: "about" */ '../views/profile/test.vue')
    },
    {
        path: '/profileLookLog',
        name: 'profileLookLog',
        meta: { page: 5 },
        component: () => import(/* webpackChunkName: "about" */ '../views/profile/lookLog.vue')
    },
    {
        path: '/profileCollection',
        name: 'profileCollection',
        meta: { page: 5 },
        component: () => import(/* webpackChunkName: "about" */ '../views/profile/collection.vue')
    },
    {
        path: '/profileMessage',
        name: 'profileMessage',
        meta: { page: 5 },
        component: () => import(/* webpackChunkName: "about" */ '../views/profile/message.vue')
    },
    {
        path: '/profileMessageDetails/:id',
        name: 'profileMessageDetails',
        meta: { page: 5 },
        component: () => import(/* webpackChunkName: "about" */ '../views/profile/messagedetails.vue')
    },
    {
        path: '/projectIndex',
        name: 'projectIndex',
        meta: { page: 3 },
        component: () => import(/* webpackChunkName: "about" */ '../views/project/index.vue')
    },
    {
        path: '/projectDetails/:id',
        name: 'projectDetails',
        meta: { page: 3 },
        component: () => import(/* webpackChunkName: "about" */ '../views/project/details.vue')
    },
    {
        path: '/companyInfo',
        name: 'companyInfo',
        meta: { page: 4 },
        component: () => import(/* webpackChunkName: "about" */ '../views/company/index.vue')
    },
    {
        path: '/teacherInfo',
        name: 'teacherInfo',
        meta: { page: 4 },
        component: () => import(/* webpackChunkName: "about" */ '../views/company/teacher.vue')
    },
    {
        path: '/companyIntroduce',
        name: 'companyIntroduce',
        meta: { page: 4 },
        component: () => import(/* webpackChunkName: "about" */ '../views/company/introduce.vue')
    },
    {
        path: '/testCenter',
        name: 'testCenter',
        meta: { page: 6 },
        component: () => import(/* webpackChunkName: "about" */ '../views/test/index.vue')
    },
    {
        path: '/testInfo/:id',
        name: 'testInfo',
        meta: { page: 6 },
        component: () => import(/* webpackChunkName: "about" */ '../views/test/info.vue')
    },
    {
        path: '/testAnalysis/:id',
        name: 'testAnalysis',
        meta: { page: 6 },
        component: () => import(/* webpackChunkName: "about" */  '../views/test/analysis.vue')
    },
    {
        path: '/recruitIndex',
        name: 'recruitIndex',
        meta: { page: 7 },
        component: () => import(/* webpackChunkName: "about" */  '../views/recruit/index.vue')
    }
]

const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, saveTop) {
        if (saveTop) {
            return saveTop;
        } else {
            return { x: 0, y: 0 }
        }
    },
})

export default router
